import React from 'react';

import { useSelector } from 'react-redux';

import _get from 'lodash/get';

import { useDevice } from '@bonnet/next/device';

import { pageNames } from '@atc/bonnet-paths';
import { useBrand } from '@atc/brand';
import { useFeatures } from '@atc/features';

import adUnits from '@/config/adUnits';

import srpAdsDuck from '@/ducks/srp/srpAdsDuck.js';

import AtcAdSlot from '@/containers/AtcAdSlot';
import DisableAdsFeatureFlag from '@/containers/global/DisableAdsFeatureFlag';

const { SEARCH_RESULTS } = pageNames;

function SRLTowerAdSlotContainer() {
    const device = useDevice();
    const hideAd = _get(device, 'lessThan.md', false);

    const { brands, isBrand } = useBrand();
    const isKbbBranded = isBrand(brands.KBB_BRAND);

    const adsLazyLoadingOffset = useSelector(srpAdsDuck.selectors.getAdsLazyLoadingOffset);
    const greaterThanMd = _get(device, 'greaterThan.md', false);

    const {
        ads: [, { srlTowerSlotId }],
    } = useFeatures(['ads']);

    const path = `${adUnits?.atcFindcar}/srp`;

    // ensure ad sizes are in order from shortest to tallest to make sure min size is smallest height
    // Remove 300x600 on ATC-SRP and KBB-SRP - only desktop
    const size = greaterThanMd ? [[300, 250], [160, 600]] : [[160, 600]];

    const targeting = {
        anml: 'N',
        pos: !isKbbBranded ? 'g' : 'G',
        prd: 'dlr',
    };

    return (
        <DisableAdsFeatureFlag>
            {!hideAd && (
                <div
                    className="margin-top-4"
                    style={{ position: 'sticky', top: '5rem' }}
                >
                    <AtcAdSlot
                        path={path}
                        showPlaceholder
                        size={size}
                        slotId={srlTowerSlotId}
                        targeting={targeting}
                        lazyLoading
                        lazyLoadingBottomOffset={adsLazyLoadingOffset}
                        lazyLoadingTopOffset={adsLazyLoadingOffset}
                        preserveSpace
                        adSelector={srpAdsDuck.selectors.getDuckState}
                        pageName={SEARCH_RESULTS}
                    />
                </div>
            )}
        </DisableAdsFeatureFlag>
    );
}

export default SRLTowerAdSlotContainer;
